import React from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormLabel,
  IconButton,
} from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import Iconify from "../iconify/Iconify";

const dateFormat = "YYYY-MM-DD HH:mm:ss";

const ContestFormFields = ({
  contest,
  handleChange,
  handleDateChange,
  uploadFiles,
}) => {
  return (
    <Grid container>
      <Grid item xs={4} sx={{ m: 0, p: 1 }}>
        <TextField
          id="title"
          label="Title"
          fullWidth
          value={contest.title}
          variant="standard"
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={8} sx={{ m: 0, p: 1 }}>
        <TextField
          id="description"
          label="Description"
          fullWidth
          value={contest.description}
          variant="standard"
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={3} sx={{ m: 0, p: 1 }}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DateTimePicker
            label="Start Date"
            value={moment(contest.startDate, dateFormat)}
            onChange={(value) => handleDateChange(value, "startDate")}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={3} sx={{ m: 0, p: 1 }}>
        <FormControl sx={{ m: 1, minWidth: 160 }} size="small">
          <InputLabel id="demo-simple-select-label">Status</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={contest.statusType ?? 0}
            label="Competition"
            onChange={(event) =>
              handleChange({
                target: {
                  id: "statusType",
                  value: event.target.value,
                },
              })
            }
          >
            <MenuItem value={0} key={`competition-0`}>
              Draft
            </MenuItem>
            <MenuItem value={1} key={`competition-1`}>
              Active
            </MenuItem>
            <MenuItem value={2} key={`competition-2`}>
              Completed
            </MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={3}>
        <FormLabel id="card-format-label">Image</FormLabel>
        <IconButton
          color="primary"
          aria-label="upload picture"
          component="label"
        >
          <input
            hidden
            accept="image/*"
            type="file"
            onChange={(event) => uploadFiles(event, "image")}
          />
          <Iconify icon={"eva:upload-outline"} sx={{ mr: 2 }} />
        </IconButton>
        {contest.image ? (
          <img
            style={{
              margin: "0 auto",
              width: 100,
              background: "grey",
            }}
            alt="Pack"
            src={contest.image}
          />
        ) : null}
      </Grid>
    </Grid>
  );
};

export default ContestFormFields;
